import { apiClient } from './api';
import { BreakTrackingService, } from './BreakTrackingServiceBase';
export { BreakTrackingService };
/**
 * Web break tracking service singleton instance
 * Uses standard web API client with cookie-based auth
 */
let _webBreakTrackingService = null;
function getWebBreakTrackingService() {
    if (!_webBreakTrackingService) {
        _webBreakTrackingService = new BreakTrackingService(apiClient);
    }
    return _webBreakTrackingService;
}
/**
 * Web break tracking service instance - exported for web app use
 */
export const breakTrackingService = getWebBreakTrackingService();
